import styled from 'styled-components';

import { Verified } from '#src/atoms/icons/Verified.tsx';

const Root = styled.span`
  color: var(--current-color);
  font: var(--t-12);
  font-weight: var(--t-bold);

  & svg {
    vertical-align: text-bottom;
    margin-right: var(--half-unit);
  }
  &.medium {
    font: var(--t-14);
  }
`;

type Props = {
  variant?: 'small' | 'medium';
};
export const SorareUser = ({ variant = 'small' }: Props) => {
  return (
    <Root className={variant}>
      <Verified />
      Sorare
    </Root>
  );
};
